import React, { useState, useEffect } from 'react'
import { generateRandomId } from '../../utils/baseStringUtils'
import { styled } from '@mui/material/styles'
import MUITooltip, { tooltipClasses } from '@mui/material/Tooltip'
import Help from '@mui/icons-material/Help'

interface ITooltipProps {
  content: string
  direction?: string
  icon?: JSX.Element
  tooltipId?: string
}

// @ts-expect-error styled items are not typed
const BootstrapTooltip = styled(({ className, ...props }) => (
  // @ts-expect-error MUI Tooltip wants specific properties already included in ...props
  <MUITooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '.9rem'
  }
}))

function Tooltip (props: ITooltipProps): JSX.Element {
  const [tooltipId, setTooltipId] = useState(`tooltip-${generateRandomId()}`)
  const [direction, setDirection] = useState('right')

  useEffect(() => {
    if (!props.tooltipId) {
      setTooltipId(`tooltip-${generateRandomId()}`)
    } else setTooltipId(props.tooltipId)
    if (props.direction) setDirection(props.direction)
  }, [])

  const renderTooltip = (): JSX.Element => {
    const tooltipIcon = props.icon ?? <Help color='secondary' fontSize='small' />

    return (
      // @ts-expect-error custom tooltip via styled
      <BootstrapTooltip placement={direction} id={tooltipId} data-testid={tooltipId} title={props.content} arrow>
        <span>{tooltipIcon}</span>
      </BootstrapTooltip>
    )
  }

  return renderTooltip()
}

export default Tooltip
